import { connect } from 'react-redux'
import { toggleNodes } from '../../selection/actions'
import {
  getChildNodesById,
  getNodeById,
} from '../../core/selectors'
import {
  getNodeSelectionById,
  getSelectionByKey,
} from '../../selection/selectors'
import ConfigurationOptions from '../components/configurationOptions'

const mapStateToProps = (state, ownProps) => ({
  configuration: getNodeById({
    state,
    id: ownProps.match.params.id,
  }),
  options: getChildNodesById({
    state,
    id: ownProps.match.params.id,
  }),
  parentSelection: getNodeSelectionById({
    state,
    id: ownProps.match.params.id,
  }),
  selection: getSelectionByKey({
    state,
    key: 'nodes',
  }),
})

const mapDispatchToProps = dispatch => ({
  handleClick: node => dispatch(toggleNodes(node)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfigurationOptions)



// WEBPACK FOOTER //
// ./src/modules/configuration/containers/configurationOptions.js